export const ENVIRONMENT = process.env.REACT_APP_ENV
export const isLocal = ENVIRONMENT === 'local'
export const isProduction = (ENVIRONMENT === 'production' || ENVIRONMENT === 'staging')

export const LIVE_SITE_URL = 'connect.alem.health'
export const LOCAL_VIEWER_URL_SEGMENT = ':8088/viewer-link/study/' // {study_guid}/

export const LOCAL_STORAGE_PREFIX = 'telemdicinewebapp-'
export const POST_COUGH_TEST_URL = `${LOCAL_STORAGE_PREFIX + ENVIRONMENT}-post-cough-test-url`

export const allowSlackNotifications = ENVIRONMENT !== 'local' && ENVIRONMENT !== 'development'
export const SLACK_APP_NAME = 'Telemedicine Web App'
export const SLACK_APP_TYPE = allowSlackNotifications ? 'LIVE' : 'TEST'
export const SLACK_WEB_HOOK = 'https://hooks.slack.com/services/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'
export const IP_VERIFY_SERVICE = 'https://ipapi.co/json/' // 'https://api.ipdata.co'
export const LOCAL_STORAGE_AUTH_KEY = {
    USER_PROFILE: `${LOCAL_STORAGE_PREFIX + ENVIRONMENT  }-auth-user-profile`,
    ACCESS_TOKEN: `${LOCAL_STORAGE_PREFIX + ENVIRONMENT  }-auth-access-token`,
    ID_TOKEN: `${LOCAL_STORAGE_PREFIX + ENVIRONMENT  }-auth-id-token`,
    EXPIRES_AT: `${LOCAL_STORAGE_PREFIX + ENVIRONMENT  }-auth-expires-at`,
    DAILLY_CHECKIN_FORM: `daily-checkin-form`,
    COVID_SCREENING_FORM: `covid-screening-form`,
    MENTAL_HEALTH_FORM: `mental-health-form`,
    STATE: `state`,
    GUEST_ID: `${LOCAL_STORAGE_PREFIX}guest-id`,
    USER_PROFILE_GUEST: `${LOCAL_STORAGE_PREFIX}profile-guest`,
    USER_PROFILE_SIGNUP: `${LOCAL_STORAGE_PREFIX}profile-signup`,
    FAMILY_PROFILE_SIGNUP: `${LOCAL_STORAGE_PREFIX}family-profile-signup`,
  }
export const SECONDS_IN_A_MINUTE = 60
export const LOCAL_STORAGE_POST_LOGIN_REDIRECT_URL = `${LOCAL_STORAGE_PREFIX + ENVIRONMENT  }-post-login-redirect`
export const REFRESH_TOKEN_WAIT_TIME = 10 * SECONDS_IN_A_MINUTE

export const EMPLOYEE_STATUS = {
  eligibleForWork : 'Eligible for Work',
  atRisk: 'At Risk - Work from Home',
  embargoed: 'Embargoed'
}

export const ACEBA_ORGANIZATION_GUID =  process.env.REACT_APP_ACEBA_ORGANIZATION_GUID
export const TIGERSWAN_ORGANIZATION_GUID =  process.env.REACT_APP_TIGERSWAN_ORGANIZATION_GUID

export const APIM_SUBSCRIPTION_KEY = process.env.REACT_APP_APIM_SUBSCRIPTION_KEY
export const DAILY_CHECKIN_RESULT_URL = `${LOCAL_STORAGE_PREFIX + ENVIRONMENT  }-daily-checkin-result-url`

export const MENTAL_HEALTH_SCREENING_DONE_FLAG = `${ENVIRONMENT}-mental-health-screening-done-flag`

export const parameterKeyMapper = {
  option: 'option',
  createdAt: 'ordering',
  offset: 'offset',
  limit: 'limit',
  sorting: 'sorting',
}

export const APPOINTMENT_TYPE = {
  upcoming: 'upcoming',
  past: 'past'
}

export const MENTAL_HEALTH_CATEGORY_REF_HEALTH_SCREENING_KEY = "health screening"
export const MENTAL_HEALTH_QUESTION_TAG_APPOINTMENT = `${LOCAL_STORAGE_PREFIX}question-tag-appointment`
export const MENTAL_HEALTH_QUESTION_HEALTH_CONCERN_APPOINTMENT = `${LOCAL_STORAGE_PREFIX}question-health-concern-appointment`